#import "../flexibleSections/flexibleSections.graphql"
#import "~/graphql/fragments/socialFragment.graphql"

fragment subsidyOverviewPageContent on subsidiesOverview_Entry {
    title
    seo {
        ... socialFragment
    }
    flexibleSections {
        ... flexibleSections
    }
    showNewsletterSubscribe
}
